import { render, staticRenderFns } from "./ResolHIUMini_2d00_P110.vue?vue&type=template&id=65ccb41e&"
import script from "./ResolHIUMini_2d00_P110.vue?vue&type=script&lang=js&"
export * from "./ResolHIUMini_2d00_P110.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports